import styled, { css } from 'styled-components'

const Container = styled.div`
  background: ${props => props.theme.cores.branco};
  box-sizing: border-box;
  display: flex;
  padding: 20px 15px;
  border: 1.5px solid ${props => props.theme.cores.cinza200};
  border-radius: 10px;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  box-shadow: rgb(0 0 0 / 12%) 0px 1px 2px 0px;
  position: relative;
  width: 100%;
  cursor: pointer;
  user-select: none;
  
  ${props => ( props.isSelected ) && css`
    border-color: ${props.color}`};
  
  > span {
    padding: 5px;
    background-color: #3F4369;
    border-radius: 5px;
    position: absolute;
    top: -15px;
    left: 14px;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    border-color: ${props => props.theme.cores.cinza200};
    flex-direction: column;
    padding: 24px;
    cursor: initial;
    max-width: 334px;
  }
`

export { Container }
